import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { ArrowUpTrayIcon } from "@heroicons/react/24/outline";

const ACCEPT = {
  "application/pdf": [".pdf"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/webp": [".webp"],
};
const MAX_SIZE = 20 * 1024 * 1024;

export function ChemicalInventoryAiDropzone({ onFile, disabled = false }) {
  const { t } = useTranslation();

  const onDrop = useCallback(
    (accepted, rejected) => {
      if (disabled) return;
      if (rejected?.length) {
        const code = rejected[0]?.errors?.[0]?.code;
        onFile(null, code === "file-too-large" ? "too_large" : "invalid_type");
        return;
      }
      const file = accepted?.[0];
      if (file) onFile(file);
    },
    [disabled, onFile]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ACCEPT,
    maxFiles: 1,
    multiple: false,
    maxSize: MAX_SIZE,
    disabled,
  });

  return (
    <div
      {...getRootProps()}
      className={`rounded-2xl border-2 border-dashed p-8 text-center transition-colors ${
        disabled
          ? "cursor-not-allowed opacity-50"
          : "cursor-pointer hover:border-[#1463C7]"
      } ${
        isDragActive
          ? "border-[#1463C7] bg-[#EAF3FD]"
          : "border-[#BFDCF7] bg-[#F8FAFC]"
      }`}
    >
      <input {...getInputProps()} />
      <ArrowUpTrayIcon className="mx-auto mb-3 h-8 w-8 text-[#1463C7]" />
      <p className="text-sm font-semibold text-slate-900">
        {t("chemical.inventory.ai_drop_title")}
      </p>
      <p className="mt-1 text-sm text-slate-600">
        {t("chemical.inventory.ai_upload_lead")}
      </p>
    </div>
  );
}
